import React from "react";
import { Link } from "react-router-dom";
import bg from "../hero-bg.jpg";
import Header from "./Header";

const Hero = ({
  mainRef,
  aboutRef,
  servicesRef,
  featuresRef,
  pricingRef,
  contactRef,
}) => {
  const handleScroll = (ref) => {
    window.scrollTo({
      top: ref.offsetTop,
      left: 0,
      behavior: "smooth",
    });
    const div = document.querySelector("#navbar");
    div.classList.remove("navbar-mobile");
    div.classList.add("navbar");
  };
  return (
    <div ref={mainRef}>
      <section
        id="hero"
        style={{
          backgroundImage: `url(${bg})`,
        }}
      >
        <Header
          mainRef={mainRef}
          aboutRef={aboutRef}
          servicesRef={servicesRef}
          featuresRef={featuresRef}
          pricingRef={pricingRef}
          contactRef={contactRef}
        />
        <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
          <h1 className="mb-4 pb-0">
            Conference
            <br />
            <span>Management</span> Tool Kit
          </h1>
          <p className="mb-4 pb-0">
            Streamline and Elevate Your Conferences with Cutting-Edge CMT
            Solutions!
            <br />
            Efficiently Manage Registrations, Schedules, and Attendee
            Experiences for Successful Conferences with our CMT Tools.
          </p>
          <Link
            className="about-btn scrollto"
            onClick={() => {
              handleScroll(aboutRef.current);
            }}
          >
            Get Started
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Hero;
